import { render, staticRenderFns } from "./BuyingSelling.vue?vue&type=template&id=6ae666c6&scoped=true"
import script from "./BuyingSelling.vue?vue&type=script&lang=js"
export * from "./BuyingSelling.vue?vue&type=script&lang=js"
import style0 from "./BuyingSelling.vue?vue&type=style&index=0&id=6ae666c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae666c6",
  null
  
)

export default component.exports